export const ACTION_PREFIX = 'STEPS';

export const actionTypes = {
  MARK_CURRENT_STEP_AS_COMPLETED: 'MARK_CURRENT_STEP_AS_COMPLETED',
  UPDATE_WORKFLOW_STEPS: 'UPDATE_WORKFLOW_STEPS',
  RESET_CURRENT_STEP: 'RESET_CURRENT_STEP',
  UPDATE_NEXT_STEP: 'UPDATE_NEXT_STEP',
  APPEND_TO_ACTIVE_STEP_LINKS: 'APPEND_TO_ACTIVE_STEP_LINKS',
  DIVERT_PROGRESS: 'DIVERT_PROGRESS',
  GLOBAL_RESET: 'GLOBAL_RESET',
  ID_VERIFICATION_MAXED: 'ID_VERIFICATION_MAXED',
};
